import { track } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { ImageToolbar } from '../ImageToolbar/ImageToolbar'
import { TextBoxToolbar } from '../TextBoxToolbar/TextBoxToolbar'
import { MaskToolbar } from '../MaskToolbar/MaskToolbar'
import { GeoShapeToolbar } from '../GeoShapeToolbar/GeoShapeToolbar'
import { VideoToolbar } from '../VideoToolbar/VideoToolbar'

const ContextToolbar = track(() => {
  const editor = useEditor()
  const selectedShape = editor.getOnlySelectedShape()

  if (!selectedShape) return null

  if (selectedShape.type === 'image') {
    return <ImageToolbar editor={editor} shapeId={selectedShape.id} />
  }
  if (selectedShape.type === 'textBox') {
    return <TextBoxToolbar editor={editor} shapeId={selectedShape.id} />
  }
  if (selectedShape.type === 'mask') {
    return <MaskToolbar editor={editor} shapeId={selectedShape.id} />
  }
  if (selectedShape.type === 'geometric') {
    return <GeoShapeToolbar editor={editor} shapeId={selectedShape.id} />
  }
  if (selectedShape.type === 'video') {
    return <VideoToolbar editor={editor} shapeId={selectedShape.id} />
  }

  return null
})

export { ContextToolbar }
